<template>
    <app-cmp-tabs default="box" v-if="this.element">
        <div class="flex" slot-scope="{ toggle, active }">
            <app-cmp-tabs-trigger name="box" :handle-click="toggle" :active="active">
                <i class="fal fa-th-large"></i>Box Model
            </app-cmp-tabs-trigger>
            <app-cmp-tabs-trigger name="design" :handle-click="toggle" :active="active">
                <i class="fal fa-pencil-alt"></i>Design
            </app-cmp-tabs-trigger>
        </div>
        <div slot="items" slot-scope="{ active }">
            <app-cmp-tabs-content name="box" :active="active">
                <app-cmp-box-model
                    :element="element.object"
                />

                <app-cmp-border
                    :element="element.object"
                />
            </app-cmp-tabs-content>
            <app-cmp-tabs-content name="design" :active="active">
                <app-cmp-design
                    :element="element.object"
                />
            </app-cmp-tabs-content>
        </div>
    </app-cmp-tabs>
</template>

<script>
    import Button from '@/components/Button';
    import CollapseableBox from '@/components/CollapseableBox';
    import CmpTabs from '@/components/composer/Tabs/Tabs';
    import CmpTabsTrigger from '@/components/composer/Tabs/TabsTrigger';
    import CmpTabsContent from '@/components/composer/Tabs/TabsContent';
    import TextField from '@/components/fields/inputs/Text';
    import SelectField from '@/components/fields/inputs/Select';
    import CmpBoxModel from '@/components/composer/Forms/Partials/BoxModel';
    import CmpBorder from '@/components/composer/Forms/Partials/Border';
    import CmpDesign from '@/components/composer/Forms/Partials/Design';
    import draggable from 'vuedraggable';

    export default {
        components: {
            'app-draggable': draggable,
            'app-button': Button,
            'app-collapseable-box': CollapseableBox,
            'app-cmp-tabs': CmpTabs,
            'app-cmp-tabs-trigger': CmpTabsTrigger,
            'app-cmp-tabs-content': CmpTabsContent,
            'app-cmp-box-model': CmpBoxModel,
            'app-cmp-border': CmpBorder,
            'app-cmp-design': CmpDesign,
            'app-field-text': TextField,
            'app-field-select': SelectField
        },
        props: {
            element: {
                type: Object,
                required: true
            }
        },
        data: () => ({
            fields: {
                label: {
                    name: 'Label',
                    attribute: 'label'
                },
                href: {
                    name: 'Href / Link',
                    attribute: 'href'
                },
                theme: {
                    name: 'Theme',
                    attribute: 'theme',
                    options: [
                        {
                            value: 'light',
                            label: 'Light'
                        },
                        {
                            value: 'dark',
                            label: 'Dark'
                        }
                    ]
                },
            },
        }),

        methods: {
            add() {
                console.log('ok')
                this.element.object.values.items.push({
                    'label': '',
                    'href': '',
                });
            },

            remove(index) {
                this.element.object.values.items.splice(index, 1);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/composer/Elements/FindLocationMapSettings.vue